const renderTrustedForm = (trustedform_cfid) => {
    return `
    <script type="text/javascript">
        (function() {
            var field = 'xxTrustedFormCertUrl';
            var provideReferrer = false;
            var invertFieldSensitivity = false;
            var tf = document.createElement('script');
            tf.type = 'text/javascript'; tf.async = true;
            tf.src = 'http' + ('https:' == document.location.protocol ? 's' : '') +
            '://api.trustedform.com/trustedform.js?field=' + escape(field) + '&l='+new Date().getTime()+Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity;
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(tf, s); }
        )();
    </script>
    <noscript>
        <img src="http://api.trustedform.com/ns.gif" />
    </noscript>
    `
}

const renderLeadId = (leadid_cfid) => {
    return `
    <script id="LeadiDscript" type="text/javascript">
    // <!--
    (function() {
    var s = document.createElement('script');
    s.id = 'LeadiDscript_campaign';
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//create.lidstatic.com/campaign/{{@system_config.jornaya.leadid_key}}.js?snippet_version=2';
    var LeadiDscript = document.getElementById('LeadiDscript');
    LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
    })();
    // -->
    </script>
    <noscript><img src='//create.leadid.com/noscript.gif?lac=934e3705-ae01-d5f3-9e2b-b9a54e634c7a&lck={{@system_config.jornaya.leadid_key}}&snippet_version=2' /></noscript>
    `
}

const renderLeadIdHidden = () => {
    return `
        <input id="leadid_token" name="universal_leadid" type="hidden" value=""/>
    `
}
const renderConsentText = (consentTextActive, consentText) => {
    if (!consentTextActive) return ''
    return `
<div class="tcpa-consent-text" >${consentText}</div>`
}

const renderSkipOption = (skipAnswer, isMultipleAnswers) => (skipAnswer && !isMultipleAnswers) && `<li class="tcpa-item-answer"><button type="button" class="tcpa-answer custom-tcpa-skip" data-id="${skipAnswer.key}" style="background-color:rgba(${skipAnswer.color}); color:rgba(${skipAnswer.fontcolor});">${skipAnswer.answer}</button></li>` || ''

const render = ({ question, answers, cfid, trustedform, trustedform_cfid, leadid, leadid_cfid, isMultipleAnswers, consentTextActive, consentText, manualSubmit = false, autoScrollToConsent = false, skipAnswer }) => {
    const checkbox = isMultipleAnswers ? `<input type="checkbox">` : '';
    const btnContinue = isMultipleAnswers ? `<div class="tcpa-continue-container"><button class="bt-continue" type="button" >Continue</button></ul>` : '';
    const answersStr = (answers || []).map(a => `<li class="tcpa-item-answer"><button type="button" class="tcpa-answer ${isMultipleAnswers ? 'multiple' : ''}" data-id="${a.key}" ${a.linkout ? `data-url="${a.url}"` : ''} {{#dnd-safe}} style="background-color:rgba(${a.color}); color:rgba(${a.fontcolor});" {{/dnd-safe}} >${checkbox}${a.answer}</button></li>`).join("\n");
    const trustedFormStr = trustedform === true ? renderTrustedForm(trustedform_cfid) : ''
    const leadIdStr = leadid === true ? renderLeadId(leadid_cfid) : ''
    const requiredFeedback = `<span class='invalid-feedback tcpa-required-feedback'>Please, select an option.</span>`
    const skipOpt = renderSkipOption(skipAnswer, isMultipleAnswers)

    return `
<form class="tcpa-questionary-form">
<div class="tcpa-questionary" data-tcpa="question" data-question="${cfid}" 
            data-trustedform="${trustedform_cfid || ''}" data-leadid="${leadid_cfid || ''}" data-key="{pe_key}" data-multiple="${isMultipleAnswers}" data-manual-submit="${manualSubmit}" data-auto-scroll-to-consent="${autoScrollToConsent}">
<div class="tcpa-question">${question ? question : ''}</div>
<ul class="tcpa-answers ${manualSubmit ? 'tcpa-required' : ''}">
${answersStr}
${skipOpt}
</ul>
${manualSubmit ? requiredFeedback : ''}
${btnContinue}
</div>
${renderConsentText(consentTextActive, consentText)}
${trustedFormStr}
${leadid === true ? renderLeadIdHidden() : ''}
</form>
${leadIdStr}
{{#dnd-safe}}
<style>
    .tcpa-consent-text { font-size: 90%; text-align: center; margin-top: 0.75rem; }
    .tcpa-questionary {width:80%; margin: 0 auto;}
    .tcpa-question {text-align: center; font-weight:bold;font-size:20px;width:100%;}
    .tcpa-answers {list-style-type:none; text-align:center; padding: 0; }
    .tcpa-item-answer {display: block;} 
    .tcpa-item-answer button {display: inline-block; }
    .tcpa-item-answer button.multiple {display: inline-flex; }
    .tcpa-answers button, .tcpa-continue-container button { border-radius: 5px; min-width: 200px; height: 40px; border: 0; margin-bottom: 10px; margin-right: 10px !important; font-weight: bold; cursor: pointer;}
    .tcpa-continue-container {text-align:center;}
    .tcpa-continue-container button {background-color:#dadada;}

    .tcpa-required.error ~ .tcpa-required-feedback { display: block; }

    @media (hover:none), (hover:on-demand) {
      button:hover { 
        /* suppress hover effect on devices that don't support hover fully */
        background: none;
      }
    }
</style>
{{/dnd-safe}}
    `.trim()
};

export default render;